<template>
  <div class="login" :style="loginStyle">

    <img class="login-bg-img" :src="require('../assets/' + picName + '')" />

    <div style="display:flex;width:100%;height:100%;">

      <div style="width: 30%;height: 100%;display: inline;position: fixed;top: 100px;right: 100px;">

        <div style="width:88%;height:50px;margin-bottom: 40px;">

          <span style="line-height: 50px;font-size:38px;color: black;">乌鸦背调</span>
        </div>

        <div style="width: 510px;height:410px;background-color: white;border-radius: 20px;">

          <div id="login_container">1</div>

        </div>
      </div>

    </div>

    <p style="position: fixed;bottom: 0px;right: 47%;">
      <a href="https://beian.miit.gov.cn" style="text-decoration: none;">
        <span style="color: black;">粤ICP备2022114400号-8</span>
      </a>
    </p>

  </div>
</template>

<script>
// @ is an alias to /src
// import Loginpage from '@/assets/images/login.png';

export default {
  name: "Login",
  components: {},
  data() {
    return {
      token: this.getToken(),

      picName: 'mianshi-1.jpeg',

      loginStyle: {
        width: '100%',
        height: document.documentElement.clientHeight
      }
    }
  },
  methods: {

  },
  mounted() {

    this.loginStyle.height = (document.documentElement.clientHeight) + 'px'

    var obj = new WxLogin({
      self_redirect: false,
      id: "login_container",
      appid: "wxaa1d6953c604c1c4",
      scope: "snsapi_login",
      redirect_uri: "https://www.ctshake.cn/shiro/wx/login",
      // front_url:"",
      state: "",
      style: "",
      href: ""
    })

    window.onresize = () => {
      return (() => {
        
        this.$nextTick(() => {

          this.loginStyle.height = (document.documentElement.clientHeight - 5) + 'px'

        })
        
      })()
    }

  }
}
</script>

<style>
body {
  padding: 0;
  margin: 0;
}

.login {
  background-color: coral;
  /* z-index: -1; */
}

#login_container {
  background-color: white;
  border-radius: 20px;
}

.login-bg-img {
  position: absolute;
  top: 200px;
  left: 40px;
  width: 55%;
}
</style>